import { useMemo } from 'react'
import { SketchElement } from '../../../../../../inspector'

/**
 * The name displayed in the overview is sometimes more than just the layer name.
 * Symbols can be named in Sketch with Slashes in the name.
 * E.g. `Primitive/Icon/Arrow/Right`. Slashes in symbol names act like groups,
 * and the name gets divided into symbolMasterNamePath and symbolMasterShortName
 * if that's the case.
 */
export function useDisplayedLayerNameAndOptionalPath(
  sketchElement: SketchElement | undefined
): { displayedName: string; symbolNamePath: string[] } {
  return useMemo(() => {
    if (!sketchElement) {
      return { displayedName: '', symbolNamePath: [] }
    }

    if (sketchElement.type !== 'symbolMaster') {
      return {
        displayedName: sketchElement.name,
        symbolNamePath: [],
      }
    }

    if (
      sketchElement.symbolMasterNamePath?.length &&
      sketchElement.symbolMasterShortName
    ) {
      return {
        displayedName: sketchElement.symbolMasterShortName,
        symbolNamePath: sketchElement.symbolMasterNamePath,
      }
    }

    return {
      displayedName: sketchElement.name,
      symbolNamePath: [],
    }
  }, [sketchElement])
}
